import React, {useState} from 'react';
import Sidebar from './Sidebar';
import {Menu, X} from 'lucide-react';

const Layout = ({children}) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="flex h-screen bg-gray-100">
            {/* Mobile sidebar toggle */}
            <div className="lg:hidden fixed top-4 left-4 z-40">
                <button
                    onClick={toggleSidebar}
                    className="p-2 rounded-md bg-blue-600 text-white"
                >
                    {sidebarOpen ? <X size={24}/> : <Menu size={24}/>}
                </button>
            </div>

            {/* Sidebar - hidden on mobile unless toggled */}
            <div className={`
        lg:relative fixed inset-y-0 left-0 z-30
        transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
        lg:translate-x-0 transition duration-200 ease-in-out
      `}>
                <Sidebar/>
            </div>

            {/* Backdrop - only on mobile */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
                    onClick={toggleSidebar}
                />
            )}

            {/* Main content */}
            <main className="flex-1 bg-gray-50 overflow-auto p-6">
                <div className="container mx-auto">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default Layout;